var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"justify-center",class:{ 'col-xl-8 offset-xl-2': !_vm.fluid },attrs:{"fluid":_vm.fluid}},[_c('v-card',{attrs:{"tile":"","color":"transparent","elevation":"0"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }